import lalamoveLogo from '@assets/third_logos/lalamove_logo.png'
import borzoLogo from '@assets/third_logos/borzo_logo.png'
import mottuLogo from '@assets/third_logos/mottu_logo.png'
import hubiiLogo from '@assets/third_logos/hubii_logo.png'
import rappiLogo from '@assets/third_logos/rappi_logo.png'
import mercadoLivreLogo from '@assets/third_logos/mercado_livre_logo.png'
import intelipostLogo from '@assets/third_logos/intelipost_logo.png'
import letsDeliveryLogo from '@assets/third_logos/lets_delivery_logo.png'

export enum EOrderShippingOperator {
  Borzo = 'borzo',
  Own = 'own',
  Lalamove = 'lalamove',
  Mottu = 'mottu',
  Rappi = 'rappi',
  Flex = 'meli-flex',
  Intelipost = 'intelipost',
  LetsDelivery = 'letsdelivery',
}

export const shippingOperatorLabels = {
  [EOrderShippingOperator.Lalamove]: 'Lalamove',
  [EOrderShippingOperator.Borzo]: 'Borzo',
  [EOrderShippingOperator.Own]: 'Entrega Hub',
  [EOrderShippingOperator.Mottu]: 'Mottu',
  [EOrderShippingOperator.Rappi]: 'Rappi',
  [EOrderShippingOperator.Flex]: 'Mercado Livre Flex',
  [EOrderShippingOperator.Intelipost]: 'Intelipost',
  [EOrderShippingOperator.LetsDelivery]: 'Lets Delivery',
}

export const orderDeliveryOperatorLogo = {
  [EOrderShippingOperator.Lalamove]: lalamoveLogo,
  [EOrderShippingOperator.Borzo]: borzoLogo,
  [EOrderShippingOperator.Mottu]: mottuLogo,
  [EOrderShippingOperator.Own]: hubiiLogo,
  [EOrderShippingOperator.Rappi]: rappiLogo,
  [EOrderShippingOperator.Flex]: mercadoLivreLogo,
  [EOrderShippingOperator.Intelipost]: intelipostLogo,
  [EOrderShippingOperator.LetsDelivery]: letsDeliveryLogo,
}